import graphApiSlice from 'src/shared/state/api-slices/graphApiSlice';

import { SamplingEvent, ProgressStatus, CMSHabitatAssayTypeWithoutImage, SurveySamplingCadenceType } from 'src/shared/types';
import {
    CreateSurveyDesignQueryResult,
    createSurveyDesignQuery,
    SurveyDesignCompletionQueryResult,
    surveyDesignCompletionQuery,
} from './queries/newSurveyDesignQuery';
import { SurveyDesignSample } from '../newSurveyDesignSlice';

type HasSurveyDesignQueryParams = {
    projectId: string;
};

type CreateSurveyDesignParams = {
    customerId: string;
    projectName: string;
    projectId: string;
    projectCode: string;
    subscriptionType: string;
    surveyPublishDate: string;
    country: string;
    samplingCadenceType: SurveySamplingCadenceType;
    samplingEvent: Omit<SamplingEvent, 'kits'>[];
    samplingEventsPerYear: number;
    habitatAssayTypes: CMSHabitatAssayTypeWithoutImage[];
    projectLeadName: string;
    projectLeadEmail: string;
    projectLeadRole: string;
    sampleGroups: string[];
    status: ProgressStatus;
    surveySamples: SurveyDesignSample[];
};

const newSurveyDesignGraphSlice = graphApiSlice.injectEndpoints({
    endpoints: builder => ({
        hasSurveyDesign: builder.query<SurveyDesignCompletionQueryResult, HasSurveyDesignQueryParams>({
            query: params => ({
                body: surveyDesignCompletionQuery,
                variables: params,
            }),
        }),
        createSurveyDesign: builder.mutation<CreateSurveyDesignQueryResult, CreateSurveyDesignParams>({
            query: params => ({
                body: createSurveyDesignQuery,
                variables: { input: params },
            }),
        }),
    }),
});

export const { useCreateSurveyDesignMutation, useHasSurveyDesignQuery } = newSurveyDesignGraphSlice;
